import { render, staticRenderFns } from "./AgentWithdrawInfo.vue?vue&type=template&id=881791c0&scoped=true&"
import script from "./AgentWithdrawInfo.vue?vue&type=script&lang=js&"
export * from "./AgentWithdrawInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881791c0",
  null
  
)

export default component.exports